import { getCartSync } from '@/features/cart/model/store';
import { apiClient } from '@/shared/api';

export function logoutAction() {
  return getCartSync().runBoundary('session', () =>
    apiClient('logout', { method: 'POST' }),
  );
}
